import Vue from 'vue'
import App from './App.vue'
import webmessage from '../../globalComponents/webmessage.vue'
Vue.component('webmessage', webmessage);
Vue.config.ignoredElements = ['wsm']
Vue.config.productionTip = false

var el = document.getElementById("footerNew2020");
new Vue({
  name: "footer",
  data: {
    language: JSON.parse(el.dataset.language),
    isThai: (el.dataset.footerthai  == "true"),
    isMedUK: (el.dataset.ismeduk == "true"),
    isNutriverse: (el.dataset.isnutriverse == "true"), 
    isNonShop:(el.dataset.isnonshop == "true"),
    isadmin: (el.dataset.isadmin == "true"),
    channel: (el.dataset.channel),
    linkedin: (el.dataset.linkedin),
    facebookLink: (el.dataset.facebooklink),
    twitterLink: (el.dataset.twitter),
    instagramLink: (el.dataset.instagramlink)
  },

  render: h => h(App),
}).$mount('#footerNew2020')
